import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemUpgradeMode extends Cloneable {

    static DISABLED = new ItemUpgradeMode(0, "DISABLED");

    static PRICE = new ItemUpgradeMode(1, "PRICE");
    static ITEM_AMOUNT = new ItemUpgradeMode(2, "ITEM_AMOUNT");
    static ITEM_POINTS = new ItemUpgradeMode(3, "ITEM_POINTS");


    static _values = [
        this.DISABLED,
        this.PRICE,
        this.ITEM_AMOUNT,
        this.ITEM_POINTS
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemUpgradeMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemUpgradeMode) {
            return ItemUpgradeMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemUpgradeMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemUpgradeMode());
        } else if (target instanceof ItemUpgradeMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemUpgradeMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});